import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

import { NgForm } from '@angular/forms';

import * as _ from 'lodash';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GadgetService } from '../../services/gadget.service';
import { PlaceholderPlaylistService } from '../../services/placeholder-playlist.service';
import { PresentationParserService } from '../../services/presentation-parser.service';
import { SettingsService } from '../../services/settings.service';

@Component({
  selector: 'playlist-item',
  templateUrl: './playlist-item.component.html',
  styleUrls: ['./playlist-item.component.scss'],
  standalone: false,
})
export class PlaylistItemComponent implements OnInit {
  @Input() item: any;
  @Output() itemChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('playlistItemForm')
  public playlistItemForm: NgForm;

  _item: any;
  widgetName: string;

  isDeprecatedItem;

  constructor(
    public dialogRef: MatDialogRef<PlaylistItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { item: any },
    private placeholderPlaylistService: PlaceholderPlaylistService,
    private settingsService: SettingsService,
    private gadgetService: GadgetService,
    private presentationParserService: PresentationParserService,
  ) {
    this.item = data.item;
  }

  ngOnInit(): void {
    this._item = _.cloneDeep(this.item);

    if (this._item.type === 'presentation') {
      this.widgetName = 'Embedded Presentation';
    } else if (!this._item.objectReference && this._item.settingsUrl) {
      this.widgetName = this._item.name;
    } else if (this._item.objectReference && this._item.type === 'widget') {
      this.gadgetService
        .getGadgetById(this._item.objectReference)
        .then((gadget) => {
          this.widgetName = gadget.name;
        });
    }

    this.isDeprecatedItem = this.presentationParserService.isDeprecatedItem(
      this._item.type,
    );
  }

  showSettingsModal() {
    this.settingsService.showSettingsModal(this._item, true);
  }

  save() {
    _.assign(this.item, this._item);

    this.placeholderPlaylistService.updateItem(this.item);

    this.dialogRef.close(true);
  }

  dismiss() {
    this.dialogRef.close(false);
  }
}
